import { render, staticRenderFns } from "./FileInputIKP.vue?vue&type=template&id=242b69ef&scoped=true&lang=html&"
import script from "./FileInputIKP.vue?vue&type=script&lang=js&"
export * from "./FileInputIKP.vue?vue&type=script&lang=js&"
import style0 from "./FileInputIKP.vue?vue&type=style&index=0&id=242b69ef&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b69ef",
  null
  
)

export default component.exports